import React from 'react';

import Button from 'views/site/Button.js';
import ProductCard from 'views/site/ProductCard.js';
import { SectionHeader } from 'views/site/Section.js';
import Theme from 'styles/Theme.js';
import Utils from 'files/Utils.js';

/*
 * ProductGrid
 *
 * The storefront leads this section with the Base Network bundle and demotes
 * everything else to "or add individual devices", because a bundle is a thing
 * you can put in a cart at a price. Neither half of that is true here: there
 * is no bundle SKU and no price to anchor it with, and the job of recommending
 * a configuration belongs to the coverage quiz, which sizes it to the actual
 * house. So the devices are presented as equals and the quiz is the call to
 * action above them.
 *
 * Rendered both as a section on the home page and as the standalone products
 * view — `standalone` only adds the fixed header offset.
 */

const ProductGrid = ({ dealership, onAddToQuote, onOpenQuiz, onViewDetails, products, standalone }) => {

    const mobile = Utils.isMobile();
    const items = products || [];

    return (
        <section
        id={'products'}
        style={{
            backgroundColor: Theme.colors.white,
            paddingTop: standalone === true ? Theme.layout.headerOffset() : 0,
            width: '100%'
        }}>
            <div style={{
                margin: '0 auto',
                maxWidth: Theme.layout.maxWidth,
                padding: Theme.layout.sectionPadding()
            }}>
                <SectionHeader
                eyebrow={'What we install'}
                subtitle={'Every device talks to every other device. When one sensor detects danger the whole home sounds the alarm. You are told what happened and where, rather than forced to hunt for the alarm that started it. Each sensor below does one job properly, and which ones you need depends on your rooms rather than on a package.'}
                title={'One connected network, room by room'} />

                {onOpenQuiz && (
                    <div style={{ marginBottom: mobile ? 36 : 48, textAlign: 'center' }}>
                        <Button
                        label={'Build Your Network'}
                        onClick={onOpenQuiz}
                        style={{ fontSize: 15, padding: '14px 34px' }}
                        type={'primary'} />
                    </div>
                )}

                <div style={{
                    display: 'grid',
                    gap: 30,
                    gridTemplateColumns: mobile ? '1fr' : `repeat(${Math.min(items.length, 3)}, 1fr)`,
                    justifyItems: 'center'
                }}>
                    {items.map((product, index) => (
                        <ProductCard
                        key={product.id || index}
                        onAddToQuote={onAddToQuote}
                        onViewDetails={onViewDetails.bind(this, product)}
                        product={product} />
                    ))}
                </div>

                <span style={{
                    ...Theme.textStyles.caption({ color: Theme.colors.lightGrey, textAlign: 'center' }),
                    display: 'block',
                    marginTop: 28
                }}>{`Add anything here to build your network — An advisor from ${dealership.name} prices it after walking your home with you.`}</span>
            </div>
        </section>
    )
}

export default ProductGrid;
